//import Swal from "sweetalert2";
//import Vue from "vue";

import {
    getList,
    addCurrent,
    getSalesPersonList,
    getCurrentActionList,
    getCurrentActionDetailList,
    rejectCurrent,
    getCurrentApprovalList,
    getCurrentOpenList,
    approveAdminCurrent,
    approveAccountingCurrent,
    getCurrentUnclosedInvoiceList,
    getCurrentActionDetailListTotal,
    searchCurrent, getCurrentCodesList, getSingle, getSeries, getCurrencyCurrentList
} from "@/services/modules/current/currentService";
import {showProcessErrorMessage, showProcessSuccessMessage} from "../alertHelpers";
import store from "../store";
import {numberConverter} from "../../../helpers";

export const state = {
    currentList: [],
    currentSearchList: [],
    currentListMetaData: {},
    salesPersonList: [],
    currentListHeaders: [],
    currentListLoading: false,
    currentActionList: [],
    currentActionListHeaders: [],
    currentActionListLoading: false,
    currentActionDetailList: [],
    currentActionDetailListHeaders: [],
    currentActionDetailListLoading: false,
    currentActionDetailListTotal: {},
    currentApprovalList: [],
    currentApprovalListHeaders: [],
    currentApprovalListLoading: false,
    currentOpenList: [],
    currentOpenListHeaders: [],
    currentOpenListLoading: false,
    currentUnclosedInvoiceList: [],
    currentUnclosedInvoiceListHeaders: [],
    currentUnclosedInvoiceListLoading: false,
    currentCodesList: [],
    noCurrentMessage: "",
    seriesList: [],
    seriesListHeaders: [],
    noSeriesMessage: "",
    stockCodeList: [],
    seriesListLoading: false,
    currencyCurrentList: [],
    currencyCurrentListHeaders: [],
    currencyCurrentListLoading: false,
    noCurrencyCurrentMessage: "",
    currentDetails: [],
};

export const mutations = {
    setNoCurrentMessage(state, data) {
        state.noCurrentMessage = data;
    },
    setCurrentList(state, data) {
        state.currentList = data;
    },
    setCurrentListMetaData(state, data) {
        state.currentListMetaData = data;
    },
    setSalesPersonList(state, data) {
        state.salesPersonList = data;
    },
    setCurrentListHeaders(state, data) {
        state.currentListHeaders = data;
    },
    setCurrentListLoading(state, data) {
        state.currentListLoading = data;
    },
    setCurrentActionList(state, data) {
        state.currentActionList = data;
    },
    setCurrentActionListHeaders(state, data) {
        state.currentActionListHeaders = data;
    },
    setCurrentActionListLoading(state, data) {
        state.currentActionListLoading = data;
    },
    setCurrentActionDetailListTotal(state, data) {
        state.currentActionDetailListTotal = data;
    },
    setCurrentActionDetailList(state, data) {
        state.currentActionDetailList = data;
    },
    setCurrentActionDetailListHeaders(state, data) {
        state.currentActionDetailListHeaders = data;
    },
    setCurrentActionDetailListLoading(state, data) {
        state.currentActionDetailListLoading = data;
    },
    setCurrentApprovalList(state, data) {
        state.currentApprovalList = data;
    },
    setCurrentApprovalListHeaders(state, data) {
        state.currentApprovalListHeaders = data;
    },
    setCurrentApprovalListLoading(state, data) {
        state.currentApprovalListLoading = data;
    },
    setCurrentOpenList(state, data) {
        state.currentOpenList = data;
    },
    setCurrentOpenListHeaders(state, data) {
        state.currentOpenListHeaders = data;
    },
    setCurrentOpenListLoading(state, data) {
        state.currentOpenListLoading = data;
    },
    setCurrentUnclosedInvoiceList(state, data) {
        state.currentUnclosedInvoiceList = data;
    },
    setCurrentUnclosedInvoiceListHeaders(state, data) {
        state.currentUnclosedInvoiceListHeaders = data;
    },
    setCurrentUnclosedInvoiceListLoading(state, data) {
        state.currentUnclosedInvoiceListLoading = data;
    },
    setCurrentSearchList(state, data) {
        state.currentSearchList = data;
    },
    setCurrentCodesList(state, data) {
        state.currentCodesList = data;
    },
    setSeriesList(state, data) {
        state.seriesList = data;
    },
    setSeriesListHeaders(state, data) {
        state.seriesListHeaders = data;
    },
    setNoSeriesMessage(state, data) {
        state.noSeriesMessage = data;
    },
    setStockCodeList(state, data) {
        state.stockCodeList = data;
    },
    setSeriesListLoading(state, data) {
        state.seriesListLoading = data;
    },
    setCurrencyCurrentListLoading(state, data) {
        state.currencyCurrentListLoading = data;
    },
    setCurrencyCurrentListHeaders(state, data) {
        state.currencyCurrentListHeaders = data;
    },
    setCurrencyCurrentList(state, data) {
        state.currencyCurrentList = data;
    },
    setNoCurrencyCurrentMessage(state,data) {
        state.noCurrencyCurrentMessage = data;
    },
    setCurrentDetails(state,data) {
        state.currentDetails = data;
    }
}

export const getters = {
    getStockCodeList(state) {
        return state.stockCodeList;
    }
};

export const actions = {
    async fetchSingleCurrent(context, {params, body}) {
        let result = await getSingle(params, body)
        if (result.data.success) {
            context.commit("setCurrentDetails",result.data.data);
            return result.data.data;
        } else {
            return [];
        }

    },
    async fetchCurrentList(context, {params, body}, loading) {
        context.commit("setCurrentListLoading", true)
        let result = await getList({params, body, loading})
        context.commit("setCurrentListMetaData", {
            totalCount: result.data.totalCount,
            totalPages: result.data.totalPages
        });

        let headers = [
            {
                key: 'selection',
                label: 'Seç',
                sortable: false,
                visible: true,
                class: "text-center align-middle",

            },
            {
                key: 'code',
                label: 'Cari Kod',
                sortable: false,
                visible: true,
                class: "text-center align-middle",

            },
            {
                key: 'name',
                label: 'Ünvan',
                sortable: true,
                visible: true,
                class: "text-left align-middle",

            },
            {
                key: 'city',
                label: 'İl',
                sortable: false,
                visible: true,
                class: "text-center align-middle",

            },
            {
                key: 'town',
                label: 'İlçe',
                sortable: false,
                visible: true,
                class: "text-center align-middle",

            },
            {
                key: 'salesPersonName',
                label: 'Plasiyer',
                sortable: false,
                visible: true,
                class: "text-center align-middle",

            },
            {
                key: 'debit',
                label: 'Borç',
                sortable: true,
                visible: true,
                class: "text-center align-middle",

            },
            {
              key: 'overDueAmount',
              label: 'Vadesi Geçmiş Borç',
              sortable: false,
              visible: true,
              class: "text-center align-middle",
            },
            {
                key: 'credit',
                label: 'Alacak',
                sortable: true,
                visible: true,
                class: "text-center align-middle",

            },
            {
                key: 'balance',
                label: 'Bakiye',
                sortable: true,
                visible: true,
                class: "text-center align-middle",

            },
            {
                key: 'stockCurrentBills',
                label: 'İşlemler',
                class: 'text-center align-middle',
                visible: true,
                sortable: false,

            }
        ];
        if (store.state.settings.erpSettings.netsisCurrencySale) {
            let additionalHeaders = [
                {
                    key: 'currencyBalance',
                    label: 'Dövizli Bakiye',
                    sortable: true,
                    visible: true,
                    class: "text-center align-middle",
                }
            ];
            const indexOfBalance = headers.findIndex(header => header.key === 'balance');
            headers.splice(indexOfBalance + 1, 0, additionalHeaders.find((item) => item.key === 'currencyBalance'));
        }

        context.commit('setCurrentListHeaders', headers);
        context.commit("setCurrentListLoading", false)
        if (result.data.success) {
            context.commit("setCurrentList", result.data.data);
            return result.data.data;
        } else {
            context.commit("setCurrentList", []);
            context.commit("setNoCurrentMessage", result.data.message);
            return [];
        }
    },
    async fetchCurrentCodesList(context, {params, body}) {
        let result = await getCurrentCodesList(params, body)
        if (result.data.success) {
            context.commit("setCurrentCodesList", result.data.data);
            return result.data.data;
        } else {
            context.commit("setCurrentCodesList", []);
            return [];
        }

    },
    async currentAdd(context, {params, body}) {
        context;
        let result = await addCurrent(params, body)
        if (result.data.success) {
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
            location.reload();
        } else
            showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: result.data.message
            })
        return result;
    },

    async fetchSalesPersonList(context, {params, body}) {
        let result = await getSalesPersonList(params, body)
        context.commit("setSalesPersonList", result.data.data);
        if (result.data.success) {
            return result.data.data;
        } else
            return false;
    },

    async fetchCurrentActionList(context, {params, body}) {
        context.commit("setCurrentActionListLoading", true)
        let result = await getCurrentActionList(params, body)
        context.commit("setCurrentActionList", result.data.data);

        let headers = [
            {
                key: 'actionDate',
                label: 'Tarih',
                sortable: false,

            },
            {
                key: 'expiryDate',
                label: 'Vade Tarihi',
                sortable: true,

            },
            {
                key: 'documentNumber',
                label: 'Belge No',
                sortable: false,

            },
            {
                key: 'description',
                label: 'Açıklama',
                sortable: false,

            },
            {
                key: 'debit',
                label: 'Borç',
                sortable: true,

            },
            {
                key: 'credit',
                label: 'Alacak',
                sortable: true,

            },
            {
                key: 'balance',
                label: 'Bakiye',
                sortable: true,

            },
            {
                key: 'process',
                label: 'İşlem',
                class: 'text-center exclude-print',
                sortable: false,

            }
        ];
        if (store.state.settings.erpSettings.netsisCurrencySale) {
             headers = [
                {
                    key: 'actionDate',
                    label: 'Tarih',
                    sortable: false,

                },
                {
                    key: 'expiryDate',
                    label: 'Vade Tarihi',
                    sortable: true,

                },
                {
                    key: 'documentNumber',
                    label: 'Belge No',
                    sortable: false,

                },
                {
                    key: 'description',
                    label: 'Açıklama',
                    sortable: false,

                },
                {
                    key: 'debit',
                    label: 'Borç',
                    sortable: true,

                },
                {
                    key: 'currencyDebit',
                    label: 'Dövizli Borç',
                    class: 'text-left ',
                    sortable: false,

                },
                {
                    key: 'credit',
                    label: 'Alacak',
                    sortable: true,
                },
                {
                    key: 'currencyCredit',
                    label: 'Dövizli Alacak',
                    class: 'text-left',
                    sortable: false,

                },
                {
                    key: 'balance',
                    label: 'Bakiye',
                    sortable: true,

                },
                {
                    key: 'process',
                    label: 'İşlem',
                    class: 'text-center exclude-print',
                    sortable: false,

                }
            ]
        }

        context.commit('setCurrentActionListHeaders', headers);
        context.commit("setCurrentActionListLoading", false)

        if (result.data.success) {
            return result.data.data;
        } else
            context.commit("setNoCurrentMessage", result.data.message);
            return false;
    },

    async fetchCurrentActionListTotal(context, {params, body, urlSegments}) {
        let result = await getCurrentActionDetailListTotal(params, body, urlSegments)
        if (result.data.success) {
            let tempObject = Object.assign(result.data.data, {});
            Object.keys(tempObject).forEach((key) => {
                tempObject[key] = numberConverter(tempObject[key]);
            });
            context.commit("setCurrentActionDetailListTotal", tempObject);
            return tempObject;
        } else
            return false;
    },

    async fetchCurrentUnclosedInvoiceList(context, {params, body}) {
        context.commit("setCurrentUnclosedInvoiceListLoading", true)
        let result = await getCurrentUnclosedInvoiceList(params, body)
        context.commit("setCurrentUnclosedInvoiceList", result.data.data);
        context.commit('setCurrentUnclosedInvoiceListHeaders', [
            {
                key: 'currentCode',
                label: 'Cari Kod',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'currentName',
                label: 'Cari Ünvan',
                sortable: true,
                class: "text-left align-middle",

            },
            {
                key: 'salesPersonCode',
                label: 'Plasiyer Kodu',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'salesPersonName',
                label: 'Plasiyer Adı',
                sortable: false,
                class: "text-left align-middle",

            },
            {
                key: 'invoiceDate',
                label: 'Fatura Tarihi',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'expiryDate',
                label: 'Vade Tarihi',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'documentNumber',
                label: 'Döküman Numarası',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'invoiceAmount',
                label: 'Fatura Tutarı',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'unclosedAmount',
                label: 'Kapatılmamış Tutar',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'remainingAmount',
                label: 'Kalan Tutar',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'dayLeft',
                label: 'Kalan Gün',
                sortable: false,
                class: "text-center align-middle",

            },
            {
                key: 'invoiceDescription',
                label: 'Açıklama',
                sortable: false,
                class: "text-left align-middle",

            },
        ]);
        context.commit("setCurrentUnclosedInvoiceListLoading", false)
        if (result.data.success) {
            return result.data.data;
        } else{
            context.commit("setNoCurrentMessage", result.data.message);
            return false;
        }
    },

    async fetchCurrentActionDetailList(context, {params, body}) {
        context.commit("setCurrentActionDetailListLoading", true)
        let result = await getCurrentActionDetailList(params, body)

        let headers = [
            {
                key: 'stockCode',
                label: 'Stok Kodu',
                sortable: false,
                class: 'text-center align-middle'
            },
            {
                key: 'stockName',
                label: 'Stok Adı',
                sortable: false,
                class: 'text-left align-middle'
            },
            {
                key: 'quantity',
                label: 'Miktar',
                sortable: false,
                class: 'text-right align-middle'
            },
            {
                key: 'grossPrice',
                label: 'Birim Fiyat',
                sortable: false,
                class: 'text-center align-middle'
            },
            {
                key: 'discount',
                label: 'İskonto',
                sortable: false,
                class: 'text-center align-middle'
            },
            {
                key: 'netPrice',
                label: 'Net Fiyat',
                sortable: false,
                class: 'text-center align-middle'
            },
            {
                key: 'vat',
                label: 'KDV',
                sortable: false,
                class: 'text-center align-middle'
            },
            {
                key: 'amount',
                label: 'Tutar',
                sortable: false,
                class: 'text-center align-middle'
            },
        ];
        if (store.state.settings.erpSettings.netsisCurrencySale) {
            headers.push(
                {
                    key: 'currencyNetPrice',
                    label: 'Dövizli Net Fiyat',
                    sortable: false,
                    class: 'text-center align-middle'

                },
                {
                    key: 'currencyAmount',
                    label: 'Dövizli Tutar',
                    sortable: false,
                    class: 'text-center align-middle'

                },
                {
                    key: "currencyType",
                    label: "Döviz Tipi",
                    sortable: false,
                    class: 'text-center align-middle'
                },
                {
                    key:"series",
                    label:"Seriler",
                    sortable: false,
                    class: 'text-center align-middle'
                }
            );
        }
        context.commit('setCurrentActionDetailListHeaders', headers);
        context.commit("setCurrentActionDetailListLoading", false)
        if (result.data.success) {
            result.data.data.map(item => item.quantity = numberConverter(item.quantity))
            result.data.data.map(item => item.grossPrice = numberConverter(item.grossPrice))
            result.data.data.map(item => item.discount = numberConverter(item.discount))
            result.data.data.map(item => item.netPrice = numberConverter(item.netPrice))
            result.data.data.map(item => item.amount = numberConverter(item.amount))
            result.data.data.map(item => item.purchaseCost = numberConverter(item.purchaseCost))
            result.data.data.map(item => item.profitAmount = numberConverter(item.profitAmount))
            result.data.data.map(item => item.cost = numberConverter(item.cost))
            result.data.data.map(item => item.currencyNetPrice = numberConverter(item.currencyNetPrice))
            result.data.data.map(item => item.currencyAmount = numberConverter(item.currencyAmount))
            context.commit("setCurrentActionDetailList", result.data.data);
            return result.data.data;
        } else
            return false;
    },

    async fetchCurrentApprovalList(context, {params, body}) {
        context.commit("setCurrentApprovalListLoading", true)
        let result = await getCurrentApprovalList(params, body)
        context.commit("setCurrentApprovalList", result.data.data);
        context.commit('setCurrentApprovalListHeaders', [
            {
                key: 'currentName',
                label: 'Cari Ad',
                sortable: false,

            },
            {
                key: 'authorizeFirstName',
                label: 'Yetkili Ad Soyad',
                sortable: true,

            },
            {
                key: 'city',
                label: 'İl / İlçe',
                sortable: false,

            },
            {
                key: 'status',
                label: 'Durum',
                sortable: false,

            },
            {
                key: 'process',
                label: 'Onay / Red',
                sortable: true,
                class: 'text-center'
            }
        ]);
        context.commit("setCurrentApprovalListLoading", false)

        if (result.data.success) {
            return result.data.data;
        } else
            return false;
    },

    async fetchCurrentOpenList(context, {params, body}) {
        context.commit("setCurrentOpenListLoading", true)
        let result = await getCurrentOpenList(params, body)
        context.commit("setCurrentOpenListLoading", false)
        context.commit("setCurrentOpenList", result.data.data);
        context.commit('setCurrentOpenListHeaders', [
            {
                key: 'currentName',
                label: 'Cari Ad',
                sortable: false,

            },
            {
                key: 'authorizeFirstName',
                label: 'Yetkili Ad Soyad',
                sortable: true,

            },
            {
                key: 'city',
                label: 'İl / İlçe',
                sortable: false,

            },
            {
                key: 'status',
                label: 'Durum',
                sortable: false,

            },
            {
                key: 'process',
                label: 'Onay / Red',
                sortable: true,
                class: 'text-center'
            }
        ]);
        context.commit("setCurrentApprovalListLoading", false)

        if (result.data.success) {
            return result.data.data;
        } else
            return false;
    },

    async currentAdminApprove(context, {params, body}) {

        let result = await approveAdminCurrent(params, body)

        if (result.data.success) {
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
            context.commit("fetchCurrentApprovalList", {
                params: {
                    userId: store.auth.state.user.UserId
                },
                body: {}
            })
        } else
            showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: result.data.message
            })
    },

    async currentAccountingApprove(context, {params, body}) {

        let result = await approveAccountingCurrent(params, body)

        if (result.data.success) {
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
            context.commit("fetchCurrentApprovalList", {
                params: {
                    userId: store.auth.state.user.UserId
                },
                body: {}
            })
        } else
            showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: result.data.message
            })
    },

    async currentReject(context, {params, body}) {
        let result = await rejectCurrent(params, body)

        if (result.data.success) {
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
            context.commit("fetchCurrentApprovalList", {
                params: {
                    userId: store.auth.state.user.UserId
                },
                body: {}
            })
        } else
            showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: result.data.message
            })
    },

    async currentSearch(context, {params, body}) {

        let result = await searchCurrent(params, body)

        if (result.data.success) {
            context.commit("setCurrentSearchList", result.data.data)
            return result.data.data;
        } else {
            context.commit("setCurrentSearchList", [])
            return [];
        }


    },

    async fetchSeries(context, {params, body}) {
        context.commit("setSeriesListLoading", true);
        let result = await getSeries(params, body)
        context.commit("setSeriesListLoading", false);
        context.commit("setSeriesListHeaders",[
            {
                key: 'serieNumber1',
                label: 'Seri Numarası 1',
                sortable: false,
                class: 'text-center align-middle'
            },
            {
                key:'serieNumber2',
                label: 'Seri Numarası 2',
                sortable: false,
                class: 'text-center align-middle'
            }
        ])
        if (result.data.success) {
            context.commit("setSeriesList", result.data.data)
            return result.data.data;
        } else {
            context.commit("setSeriesList", [])
            context.commit("setNoSeriesMessage", result.data.message)
            return [];
        }
    },

    async fetchCurrencyCurrentList(context, {params, body,urlSegments}) {
        context.commit("setCurrencyCurrentListLoading", true)
        let headers = [
            {
                value: 'code',
                text: 'Cari Kodu',
                sortable: false,

            },
            {
                value: 'name',
                text: 'Cari Adı',
                sortable: false,
            },
            {
                value: 'currencyType',
                text: "Döviz Tipi",
                sortable: false,
            },
            {
                value: 'selection',
                text: 'Seç',
                sortable: false,
                class: "text-center align-middle",

            },
        ];
        let result = await getCurrencyCurrentList(params, body,urlSegments);
        context.commit('setCurrencyCurrentListHeaders', headers);
        context.commit("setCurrencyCurrentListLoading", false)
        if (result.data.success) {
            context.commit("setCurrencyCurrentList", result.data.data);
            return result.data.data;
        } else {
            context.commit("setCurrencyCurrentList", []);
            context.commit("setNoCurrencyCurrentMessage", result.data.message);
            return [];
        }
    },

};
